import { APPEARANCE_CARD_TYPE } from "src/components/WidgetMaker/WidgetDnD/GlobalStyle/globalSettingConstant";

export function globalStyleValue(radius) {
  const index = radius?.indexOf('px');
  const radiusValue = radius?.slice(0, index);
  return radiusValue

}
function checkForRadiusLimit(style, limit) {
  if (limit) {
    const radius = style?.borderRadius;
    const radiusValue = globalStyleValue(radius)
    const updatedValue = Number(radiusValue) > limit ? limit : radiusValue;
    return {
      borderRadius: `${updatedValue}px !important`
    }
  }
  return style
}
export const buttonStyle = (globalStyle, limit, limitApplyOnPill = false) => {
  const buttonStyle = globalStyle.buttons;
  switch (buttonStyle.borderType) {
    case APPEARANCE_CARD_TYPE.SHARP: {
      return buttonStyle.style
    }
    case APPEARANCE_CARD_TYPE.ROUNDED: {
      return checkForRadiusLimit(buttonStyle.style, limit)
    }
    case APPEARANCE_CARD_TYPE.PILL: {
      if (limitApplyOnPill) {
        return checkForRadiusLimit(buttonStyle.style, limit)
      }
      else {
        return buttonStyle.style
      }
    }
  }
}